import React, { useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import Container from '@mui/material/Container';
import { CssBaseline } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import DashboardRFString from './dashboard.components/DashboardRFString';
import DashboardTouchpad from './dashboard.components/DashboardTouchpad';
import DashboardTemperatureSettings from './dashboard.components/DashboardTemperatureSettings';
import DashboardGeneral from './dashboard.components/DashboardGeneral';
import DashboardControl from './dashboard.components/DashboardControl';
import DashboardButtonLEDs from './dashboard.components/DashboardButtonLEDs';
import DashboardColouredArc from './dashboard.components/DashboardColouredArc';
import DashboardPower from './dashboard.components/DashboardPower';
import DashboardDipSwitches from './dashboard.components/DashboardDipSwitches';
import DashboardSpaDetails from './dashboard.components/DashboardSpaDetails';
import DashboardWifiDetails from './dashboard.components/DashboardWifiDetails';
import DashboardMeter from './dashboard.components/DashboardMeter';
import { MainRfContext } from '../context/MainRfContext';
import { MainContext } from '../context/MainContext';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export default function Dashboard() {
  const state = useContext(MainRfContext);
  const history = useHistory();

  useEffect(() => {
    if (state?.isReady && state.deviceType === 3) {
      history.replace('/SSIG');
    }
  }, [state?.isReady, state?.deviceType, history]);

  if (!state?.isReady) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Alert variant="filled" severity="info">
            Loading…
          </Alert>
        </Stack>
      </Container>
    );
  }

  if ((state.selectedDevice === 0)) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert variant="filled" severity="error">
          No spa associated with this account
        </Alert>
      </Stack>
    </Container>)
  } else if (!state.R2 || !state.RG) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4, backgroundColor: "black" }}>
      <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
        <Alert variant="filled" severity="error">
          No RF Data Available
        </Alert>
      </Stack>
    </Container>)
  } else {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MainContext.Provider value={{ state }}>
          <Grid container spacing={3}>
            {/* Offline */}
            {state.online === false ? <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
              <Alert variant="filled" severity="error">
                Spa is Offline
              </Alert>
            </Stack> : <div></div>}
            {/* Touchpad */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 350,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardTouchpad />
              </Paper>
            </Grid>
            {/* Temp settings */}
            {/* <Grid item xs={12} md={4} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 340,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <DashboardTemperatureSettings />
              </Paper>
            </Grid> */}
            {/* ButtonLEDs */}
            {/* <Grid item xs={12} md={4} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 340,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardButtonLEDs />
              </Paper>
            </Grid> */}
            {/* Spa Details */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 350,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardSpaDetails />
              </Paper>
            </Grid>

            {/* WiFi Details */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 350,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardWifiDetails />
              </Paper>
            </Grid>

            {/* General */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 370,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardGeneral />
              </Paper>
            </Grid>

            {/* Dip Switches */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 350,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardDipSwitches />
              </Paper>
            </Grid>
            
            {/* Power */}
            <Grid item xs={12} md={6} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 370,
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardPower />
              </Paper>
            </Grid>
            
            {/* Control */}
            <Grid item xs={12}>
              <Paper sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                bgcolor: '#1E1E1E',
              }}>
                <DashboardControl />
              </Paper>
            </Grid>
            {/* Meter */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardMeter />
              </Paper>
            </Grid>
            {/* RF String */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  bgcolor: '#1E1E1E',
                }}
              >
                <DashboardRFString />
              </Paper>
            </Grid>
          </Grid>
        </MainContext.Provider>
        <Copyright sx={{ pt: 4, color: "white" }} />
      </Container>
    );
  }
}